import { ClientAnalyticsEventType } from '@/components/analytics/constants';
import { useTrackEventsAnalytics } from '@/components/analytics/hooks/use-track-events-analytics';
import { YellowButton } from '@/components/button/button';
import {
  BookingFieldsFragment,
  ExperienceEventFieldsFragment,
  ExperienceFieldsFragment,
  ExperienceMode,
} from '@/generated/graphql';
import { useCurrentUser } from '@/hooks/use-current-user/use-current-user';
import { useRelativeTime } from '@/hooks/use-relative-time';
import { getEventJoinUrl } from '@/utils/getEventJoinUrl';
import styled from '@emotion/styled';
import { useMediaQuery } from '@mui/material';
import { useJoinEvent } from '../hooks/use-join-event/use-join-event';
import { useScheduleWelcomeModalOpen } from '../hooks/use-schedule-welcome-modal-open/use-schedule-welcome-modal-open';
import { ScheduleWelcomeModal } from './schedule-welcome-modal';
import { useAuth0 } from '@/auth';
const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  width: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`;
const MobileButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-width: 107px;
`;

interface BookingButtonActionProps {
  event: ExperienceEventFieldsFragment;
  experience: ExperienceFieldsFragment;
}
const BookingButton = ({ event, experience }: BookingButtonActionProps) => {
  const { setScheduleWelcomeModalOpen } = useScheduleWelcomeModalOpen();
  const mode = experience.mode;
  const isMobile = useMediaQuery('(max-width:768px)');
  const [relativeTime, { isNow, isSoon }] = useRelativeTime(event.start, { endTime: event?.end });
  const { joinEvent } = useJoinEvent();
  const { data: user } = useCurrentUser();
  const track = useTrackEventsAnalytics();

  const { isAuthenticated } = useAuth0();

  if (!relativeTime) {
    return null;
  }
  const joinUrl = event?.overrideLink || event?.zoomMeeting?.joinUrl;

  const content = (
    <>
      {isNow && (
        <YellowButton
          href={joinUrl}
          target="_blank"
          onClick={() => {
            if (isAuthenticated) {
              track.fireEvent(ClientAnalyticsEventType.CLICKED_JOIN_EVENT, {});
            } else {
              track.fireEvent(ClientAnalyticsEventType.JOIN_EXPERIENCE_NOT_LOGGED_IN, {
                id: experience.id,
                title: experience.title!,
              });
            }
          }}
        >
          Join the experience
        </YellowButton>
      )}
      {isSoon && (
        <YellowButton href={joinUrl} target="_blank">
          Join the waiting room
        </YellowButton>
      )}
      {!isNow && !isSoon && (
        <YellowButton onClick={() => joinEvent(event.id)}>Book Experience</YellowButton>
      )}
    </>
  );

  if (mode === ExperienceMode.InPerson) {
    if (user?.welcomeVetted) {
      if (isMobile) {
        return (
          <MobileButtonRow>
            <YellowButton onClick={() => joinEvent(event.id)}>Book</YellowButton>
          </MobileButtonRow>
        );
      } else {
        return (
          <ButtonRow>
            <YellowButton onClick={() => joinEvent(event.id)}>Book Experience</YellowButton>
          </ButtonRow>
        );
      }
    } else {
      if (isMobile) {
        return (
          <MobileButtonRow>
            <YellowButton onClick={() => setScheduleWelcomeModalOpen(true)}>
              Book a Welcome
            </YellowButton>
            <ScheduleWelcomeModal />
          </MobileButtonRow>
        );
      } else {
        return (
          <ButtonRow>
            <YellowButton onClick={() => setScheduleWelcomeModalOpen(true)}>
              Book a Welcome
            </YellowButton>
            <ScheduleWelcomeModal />
          </ButtonRow>
        );
      }
    }
  } else {
    if (isMobile) {
      return <MobileButtonRow>{content}</MobileButtonRow>;
    } else {
      return <ButtonRow>{content}</ButtonRow>;
    }
  }
};

export default BookingButton;
